import { Trans } from "@lingui/react";
import { useOrganisation } from "../../context/DealerDataProviderContext.tsx";
import { Icon } from "./Icon.tsx";

export const BrandAuthorizations = () => {
  const { authorizedBrandDealer } = useOrganisation();

  const brands = authorizedBrandDealer ? Object.values(authorizedBrandDealer).flat() : [];

  if (!brands || brands.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col mt-40">
      <h2 className="t3 mb-0">
        <Trans id="dealerBrandingLayout.authorizations.title" message="Authorized dealer of" />
      </h2>
      <ul className="flex flex-wrap gap-12 pt-12">
        {brands.map((brand) => (
          <li key={brand} className="flex gap-8">
            <Icon name="Warranty" className="shrink-0 mt-2 s-icon" />
            <span className="font-bold">{brand}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
